// Match Day — Squad: who starts, who is on the bench. Seeded from the official lineup when one
// exists; the trainer fixes it here before kick-off. Stored per match (matchday_squad), never
// written back to Squad Builder.
import React from 'react';
import { seedSquad, setRole } from './matchdayStore';
import { Badge, C, ConfirmBtn } from './ui';

const ROLES = [
  { id: 'starter', label: 'Start', color: C.blue },
  { id: 'bench', label: 'Bench', color: C.green },
  { id: null, label: 'Out', color: 'var(--text-muted)' },
];

export default function SquadTab({ state, commit, phase }) {
  const roleOf = new Map(state.squad.filter(s => !s.deletedAt).map(s => [s.playerId, s.role]));
  const starters = [...roleOf.values()].filter(r => r === 'starter').length;
  const bench = [...roleOf.values()].filter(r => r === 'bench').length;
  const players = state.players.slice().sort((a, b) =>
    (a.isGoalkeeper === b.isGoalkeeper ? 0 : a.isGoalkeeper ? -1 : 1) || ((a.squadNumber ?? 999) - (b.squadNumber ?? 999)) || a.name.localeCompare(b.name));
  const seed = state.lineupSeed;

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center' }}>
        <Badge color={starters === 11 ? C.green : C.amber} style={{ fontSize: 15, padding: '6px 12px' }}>Starters {starters} / 11</Badge>
        <Badge style={{ fontSize: 15, padding: '6px 12px' }}>Bench {bench}</Badge>
        {seed && (
          <ConfirmBtn style={{ marginLeft: 'auto' }}
            confirmLabel={`Tap again: replace with lineup (${seed.starters.length} + ${seed.bench.length})`}
            onConfirm={() => commit(s => seedSquad(s, seed))}>
            Use official lineup
          </ConfirmBtn>
        )}
      </div>
      {phase !== 'pre' && (
        <div style={{ color: C.amber, fontWeight: 700 }}>The match is running — changing a starter changes his minutes. Use the sub flow for real substitutions.</div>
      )}
      {!seed && !state.squad.length && (
        <div style={{ color: 'var(--text-muted)' }}>No official lineup for this match — pick starters and bench below.</div>
      )}
      <div style={{ display: 'grid', gap: 6 }}>
        {players.map(p => {
          const role = roleOf.get(p.id) || null;
          return (
            <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 10px', borderRadius: 12, background: role ? 'var(--bg-card)' : 'transparent', border: '1px solid var(--border)' }}>
              <span style={{ width: 30, fontWeight: 800, color: 'var(--text-muted)' }}>{p.squadNumber ?? ''}</span>
              <span style={{ flex: 1, fontSize: 16, fontWeight: 600, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</span>
              <Badge>{p.position || '—'}</Badge>
              <div style={{ display: 'flex', gap: 6 }}>
                {ROLES.map(r => {
                  const on = role === r.id;
                  return (
                    <button key={String(r.id)} type="button" onClick={() => commit(s => setRole(s, p.id, r.id))}
                      style={{
                        minWidth: 68, minHeight: 44, borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: 'pointer', touchAction: 'manipulation',
                        border: `2px solid ${on ? r.color : 'var(--border)'}`, background: on ? r.color : 'transparent',
                        color: on ? '#fff' : 'var(--text-secondary)',
                      }}>{r.label}</button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
